import './config/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign browser extension errors that don't affect functionality
// These errors occur when extensions (password managers, ad blockers, etc.)
// intercept requests but don't respond before the channel closes
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason);
  if (
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('listener indicated an asynchronous response') ||
    errorMessage.includes('Extension context invalidated')
  ) {
    console.debug('[Browser Extension] Suppressed benign error:', errorMessage);
    event.preventDefault();
    return;
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
